module.exports = __webpack_public_path__ + "static/media/img_5.4ab2e05c.png";